import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { NotificationService } from '@progress/kendo-angular-notification';
import { SelectEvent } from 'node_modules/@progress/kendo-angular-layout/tabstrip/events';
import { BehaviorSubject, finalize } from 'rxjs';
import { formatStartToAPI } from 'src/app/modules/administration/constants/scheduler';
import { MANDATE_STATUS } from 'src/app/modules/provider-management/constants/mandates-status.constants';
import { ICompareMandatesPaylaod } from 'src/app/modules/provider-management/interfaces/compare-mandates-payload';
import { ICurrentEventData } from 'src/app/modules/provider-management/interfaces/current-event-data';
import { IAnnualGoalsResposne, IMandatesCompareResponse, IMandateseAssignmentCompare } from 'src/app/modules/provider-management/interfaces/mandates-compare-response';
import { IProviderMeetingDetails } from 'src/app/modules/provider-management/interfaces/pa-meeting-details';
import { Assignments } from 'src/app/modules/provider-management/models/schedule-save-model';
import { ProviderManagementService } from 'src/app/modules/provider-management/services/provider-management.service';
import { LoadingService } from 'src/app/services/loading.service';
import { User } from 'src/app/shared/models/user';
import { AuthStore } from 'src/app/stores/auth.store';
import { IProviderManagementInfo } from '../../../modules/provider-management/constants/provider-management-routes';
import { DashboardPMResponse } from '../../../modules/provider-management/interfaces/pm-dashboard.response';
import { SchedulerEditService } from '../../../shared/services/scheduler-edit.service';
import { EvaluatorAvailabilityRequest } from '../../interfaces/evaluator-session-avaliablity';
import { ProviderAvailabilityResponseItem, ProviderSessionAvailability } from '../../interfaces/provider-seession-avaliability';
import { ScheduleDetailsComponent } from '../schedule-details/schedule-details.component';
import { ScheduleEvaluationDialogboxComponent } from '../schedule-evaluation-dialogbox/schedule-evaluation-dialogbox.component';
import { SessionType } from '../../enums/session-type';
import { showAvailabilityNotification } from '../../functions/availability-notification';

@Component({
  selector: 'app-schedule-time',
  templateUrl: './schedule-time.component.html',
  styleUrls: ['./schedule-time.component.scss'],
  standalone: false
})
export class ScheduleTimeComponent extends DialogContentBase implements OnInit {
  @Input() fromCreateServiceEntry: boolean = false;
  @Input() fromEncounterAttendance: boolean = false;
  @Input() preselectedSessionTypeId?: number;
  scheduleTiimeSelected: boolean = true;
  public showSessionSeriesBanner = false;
  isEditingSession: boolean = undefined;
  isEdititingMeetingSeries: boolean = false;
  @ViewChild(ScheduleDetailsComponent)
  scheduleDetailsCmp!: ScheduleDetailsComponent;
  @ViewChild(ScheduleEvaluationDialogboxComponent)
  scheduleEvaluatorCmp!: ScheduleEvaluationDialogboxComponent;
  providerManagementInfo: IProviderManagementInfo;
  public payload: ProviderSessionAvailability;
  isNew: boolean = true;
  meetingSk: string = '';
  public startDate: Date;
  public startTime: Date;
  public endTime: Date;
  public selectedMandates: DashboardPMResponse[];
  public user: User;
  @Input() isOpenedFromProvider: boolean;
  @Input() isOpenedFromEvaluator: boolean;
  @Input() isOpenedFromIEPMeeting: boolean;
  public selectedTabIndex: number = 0;
  showUpload$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  mandateInfo: DashboardPMResponse;
  public displayScheduleTimeButton: boolean;
  showScheduleAssignmentBtn: boolean;
  clickEmptySchedule: boolean;
  showSchedulerError: boolean;
  studentsSelected: boolean;
  selecteStudentdMandates: any;
  isSchedulerAdd: boolean;
  selectedMandatesDetails: DashboardPMResponse[];
  payloads: EvaluatorAvailabilityRequest;
  schedulerPopupOpen: boolean;
  addSelectionToGroup: boolean;
  recurringMeetingSk: string;
  indirectType: boolean;
  selectionCompare: boolean;
  editMandateIds: string[];
  editAssessments: string[] | Assignments[];
  encounterLog: boolean = false;
  public compareMandatesGridView: IMandateseAssignmentCompare[] = [];
  public annualGoalsGridView: IAnnualGoalsResposne[] = [];
  readonly indexNumberThree: number = 3;
  showErrorPopup: boolean;
  editStartDate: Date;
  editStartTime: Date;
  studentSk: string;
  editSelectedMandates: ICurrentEventData[];
  readonly padStartLength: number = 2;
  readonly sessionTypeNonStudentId: number = 1;
  showForAssignedStudent: boolean;
  openedFromInlineSchedule = false;
  scheduleFormDetails: any;
  constructor(
    library: FaIconLibrary,
    dialog: DialogRef,
    public scheduleEditService: SchedulerEditService,
    private authStore: AuthStore,
    private providerManagementService: ProviderManagementService,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
  ) {
    super(dialog);
    library.addIcons(faCalendar);
    this.user = this.authStore.UserInfo;
  }
  ngOnInit(): void {
    if (!this.isNew) {
      this.getPAMeetingDetails();
    } else if (!this.encounterLog) {
      this.getCompareMandateDetails();
    }
  }
  getPAMeetingDetails(): void {
    this.providerManagementService
      .getPAMeeting(this.meetingSk)
      .pipe(

        finalize(() => this.loadingService.hide())
      )
      .subscribe({
        next: (res: IProviderMeetingDetails) => {
          if (res) {
            this.editMandateIds = res?.Mandates;
            this.editAssessments = res?.Assignments;
            this.getCompareMandateDetails();
          }

        },

      });
  }

  getCompareMandateDetails(): void {
    this.loadingService.show();
    const mandateSks: string[] = this.editSelectedMandates?.length > 0 ? this.editSelectedMandates?.map(
      (res: DashboardPMResponse) => {
        return res.mandateSk;
      }
    ) : this.selectedMandates ? this.selectedMandates?.map(
      (res: DashboardPMResponse) => {
        return res.mandateSk;
      }
    ) : this.editMandateIds

    const AssessmentSk: string[] = this.editSelectedMandates?.length > 0 ? this.editSelectedMandates?.map(
      (res: DashboardPMResponse) => {
        return res.assignmentSk;
      }
    ) : this.selectedMandates ? this.selectedMandates?.map(
      (res: DashboardPMResponse) => {
        return res.assignmentSk;
      }
    ) : this.editAssessments as any;
    const studentSks: string[] = this.editSelectedMandates?.length > 0 ? this.editSelectedMandates?.map(
      (res: DashboardPMResponse) => {
        return res.studentSK;
      }
    ) : this.selectedMandates?.map(
      (res: DashboardPMResponse) => {
        return res.studentSK;
      }
    );
    const payload: ICompareMandatesPaylaod = {
      providerSk: this.user.personSk,
      mandateSks: mandateSks,
      studentSks: studentSks,
      assignmentSks: AssessmentSk,
    };
    this.providerManagementService
      .getCompareMandates(payload)
      .pipe(
        finalize(() => (this.loadingService.hide()))
      )
      .subscribe({
        next: (res: IMandatesCompareResponse) => {
          this.compareMandatesGridView = res.mandateAssignmentCompare;
          this.annualGoalsGridView = res.getStudentAnualGoals;
        },
      });
  }
  override ngAfterViewInit(): void {
    super.ngAfterViewInit(); // ensuring DialogContentBase lifecycle runs
    if (this.preselectedSessionTypeId !== undefined && this.preselectedSessionTypeId !== null) {
      this.scheduleDetailsCmp?.scheduleDetailsForm
        ?.get('sessionType')
        ?.setValue(this.preselectedSessionTypeId);
    }
  }

  onScheduleTime(): void {
    const lanaguage: boolean = this.scheduleDetailsCmp?.checkValidLanguages;
    const duration: boolean = this.scheduleDetailsCmp?.checkValidDuration;
    const serviceType: boolean = this.scheduleDetailsCmp?.checkValidServiceTypes;
    const size: boolean = this.scheduleDetailsCmp?.checkGroupeSize;
    const startDate: boolean = this.scheduleDetailsCmp?.checkValidServiceStartDate;
    const ageCheck: boolean = this.scheduleDetailsCmp?.checkValidGradeorAge;
    const endDate: boolean = this.scheduleDetailsCmp?.showEndData ? this.scheduleDetailsCmp?.checkAssignmentEndDate : true
    if (this.studentsSelected) {
      this.payloads = new EvaluatorAvailabilityRequest({
        providerSK: this.user?.providerSk,
        startTime: this.formatTo24HourTime(this.getScheduleDetailsFormGroup?.value?.startTime),
        endTime: this.formatTo24HourTime(this.getScheduleDetailsFormGroup?.value?.endTime),
        meetingSk: this.getScheduleDetailsFormGroup?.value?.meetingSk

      });
      if (this.getScheduleDetailsFormGroup?.value?.startDate) {
        this.payloads.checkDate = formatStartToAPI(this.getScheduleDetailsFormGroup?.value?.startDate);
      }

      this.loadingService.show();
      this.providerManagementService.GetEvaluatorSessionAvailability(this.payloads).subscribe((data: { availability: string }) => {
        if (data?.availability?.trim() === 'Available') {
          this.loadingService.hide();
          this.dialog.close(this.getScheduleDetailsFormGroup);
        } else {
          showAvailabilityNotification([data], this.notificationService);
          this.loadingService.hide();
        }

      })
    } else {
      const sessionTypeValue = this.scheduleDetailsCmp?.scheduleDetailsForm?.get('sessionType')?.value;
      if (sessionTypeValue?.id === SessionType.RelatedServicesAppointment) {
        const selectedMandates = this.getScheduleDetailsFormGroup?.value?.studentMandates ?? [];
        const hasMandates = selectedMandates.length > 0;
        const hasUnacceptedMandates = selectedMandates.some(m => m.status !== MANDATE_STATUS.pendingScheduling && m.status !== MANDATE_STATUS.awaitingFirstAttend);
        if (!hasMandates) {
          this.showSchedulerError = true;
          return;
        } else if (hasUnacceptedMandates) {
          this.showSchedulerError = true;
          return;
        } else {
          this.showSchedulerError = false;
        }
      }
      else {
        if (this.selectedMandates?.length > 0 ||
          this.getScheduleDetailsFormGroup?.value?.studentMandates?.length > 0) {
          this.showErrorPopup = true;
        } else {
          this.showErrorPopup = false;
        }

      }
      if (lanaguage && duration && serviceType && size && startDate && endDate && ageCheck &&
        this.scheduleDetailsCmp?.scheduleDetailsForm?.get('serviceType')?.value?.id !== this.indexNumberThree) {
        this.payload = new ProviderSessionAvailability({
          ...this.getScheduleDetailsFormGroup?.value,
          providerSK: this.user?.providerSk,
          startTime: this.formatTo24HourTime(this.getScheduleDetailsFormGroup?.value?.startTime),
          endTime: this.formatTo24HourTime(this.getScheduleDetailsFormGroup?.value?.endTime),
          daysOfWeek: this.formatWeekDays(this.getScheduleDetailsFormGroup?.value?.weekDayChip),
          isEditingSession: this.isEditingSession,
          details: this.scheduleDetailsCmp.meetingDetails,
          meetingSk: this.scheduleDetailsCmp?.meetingSk,
          isAdd: this.isNew ? true : false,
          editMode: this.isNew ? 0 : 1,

        });
        if (!this.isNew) {
          this.payload.canceledDate = formatStartToAPI(this.scheduleDetailsCmp?.startDate);
        }

        this.loadingService.show();
        this.providerManagementService.GetProviderSessionAvailability(this.payload).subscribe((data: ProviderAvailabilityResponseItem[]) => {
          if (this.isAllAvailable(data)) {
            this.loadingService.hide();
            this.dialog.close(this.getScheduleDetailsFormGroup);
          } else {
            showAvailabilityNotification(data, this.notificationService);
            this.loadingService.hide();
          }

        })
      }

      else if (this.getScheduleDetailsFormGroup?.value?.sessionType?.id !== this.sessionTypeNonStudentId) {
        this.payload = new ProviderSessionAvailability({
          ...this.getScheduleDetailsFormGroup?.value,
          providerSK: this.user?.providerSk,
          startTime: this.formatTo24HourTime(this.getScheduleDetailsFormGroup?.value?.startTime),
          endTime: this.formatTo24HourTime(this.getScheduleDetailsFormGroup?.value?.endTime),
          daysOfWeek: this.formatWeekDays(this.getScheduleDetailsFormGroup?.value?.weekDayChip),
          isEditingSession: this.isEditingSession,
          details: this.scheduleDetailsCmp.meetingDetails,
          meetingSk: this.scheduleDetailsCmp?.meetingSk,
          isAdd: this.isNew ? true : false,
          editMode: this.isNew ? 0 : 1,

        });
        if (!this.isNew) {
          this.payload.canceledDate = formatStartToAPI(this.scheduleDetailsCmp?.startDate);
        }

        this.loadingService.show();
        this.providerManagementService.GetProviderSessionAvailability(this.payload).subscribe((data: ProviderAvailabilityResponseItem[]) => {
          if (this.isAllAvailable(data)) {
            this.loadingService.hide();
            this.dialog.close(this.getScheduleDetailsFormGroup);
          } else {
            showAvailabilityNotification(data, this.notificationService);
            this.loadingService.hide();
          }

        })
      } else {
        this.showSchedulerError = true;
      }
    }

  }
  formatWeekDays(days: number[]): string {
    const WEEKDAY_MAP: Record<number, string> = {
      1: 'MON',
      2: 'TUE',
      3: 'WED',
      4: 'THU',
      5: 'FRI',
      6: 'SAT',
      7: 'SUN'
    };
    if (!Array.isArray(days)) return '';

    return days
      .map((d: number) => WEEKDAY_MAP[d])
      .filter(Boolean)
      .join(', ');
  }
  formatTo24HourTime(isoString: string): string {
    if (!isoString) return '';

    const date: Date = new Date(isoString);

    const hours: string = date.getHours().toString().padStart(this.padStartLength, '0');
    const minutes: string = date.getMinutes().toString().padStart(this.padStartLength, '0');

    return `${hours}:${minutes}`;
  }

  public isAllAvailable(data: { availability: string }[]): boolean {
    return data?.every(
      (item: { availability: string }) => item?.availability?.trim() === 'Available'
    );
  }
  get getScheduleDetailsFormGroup(): FormGroup | undefined {
    if (this.studentsSelected) {
      return this.scheduleEvaluatorCmp?.scheduleDetailsForm
        ? this.scheduleEvaluatorCmp?.scheduleDetailsForm
        : undefined;
    } else {
      return this.scheduleDetailsCmp?.scheduleDetailsForm
        ? this.scheduleDetailsCmp?.scheduleDetailsForm
        : undefined;


    }

  }
  get scheduleWeekly(): boolean {
    let isWeekly: boolean;
    this.providerManagementService.isWeekySelected$.subscribe((res: boolean) => {
      if (res) {
        isWeekly = res;
      } else {
        isWeekly = res;
      }
    });
    return isWeekly;
  }
  get disableScheduleForm(): boolean {
    const detailsInvalid =
      this.scheduleDetailsCmp?.scheduleDetailsForm?.invalid ||
      this.scheduleEvaluatorCmp?.scheduleDetailsForm?.invalid;

    if (detailsInvalid) {
      return true;
    }

    const sessionTypeValue = this.scheduleDetailsCmp?.scheduleDetailsForm?.get('sessionType')?.value;
    if (sessionTypeValue === 0 || sessionTypeValue === null) {
      return true;
    }

    if (
      this.fromEncounterAttendance &&
      this.scheduleDetailsCmp?.isStudentMissingForLog
    ) {
      return true;
    }

    return false;
  }

  onTabSelect(e: SelectEvent): void {
    this.selectedTabIndex = e.index;
  }

  onMandateInfo(event: any): void {
    this.mandateInfo = event;
  }

  get isDisplayScheduleAssistant(): boolean {
    //Dev: Currently showing Schedule Assistant tab for 'Awaiting Service Confirmation' (Related Service Appointment).
    // TODO: Once evaluator screens are ready, enable it for Evaluator Appointments as well. This is as per Dev Notes in WF.
    return (
      this.providerManagementInfo?.statusID ===
      MANDATE_STATUS.AwaitingServiceConfirmation && this.displayScheduleTimeButton
    );
  }
  onChildDialogClosed(result: boolean): void {
    if (result) {
      this.dialog.close(this.getScheduleDetailsFormGroup);
    }
    this.showSchedulerError = false;
  }

}
